import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Blessing {
  id: number;
  name: string;
  message: string;
  date: string;
}

interface BlessingCardProps {
  blessing: Blessing;
}

const BlessingCard = ({ blessing }: BlessingCardProps) => {
  return (
    <div className="bg-card rounded-lg p-6 border border-border shadow-sm hover:shadow-md transition-shadow duration-300">
      <div className="flex items-start space-x-3 mb-4">
        <div className="flex-shrink-0">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon name="HeartIcon" size={20} className="text-primary" variant="solid" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-inter text-sm font-semibold text-foreground">
            {blessing.name}
          </h3>
          <p className="font-inter text-xs text-muted-foreground mt-0.5">
            {blessing.date}
          </p>
        </div>
      </div>
      <p className="font-inter text-sm text-foreground leading-relaxed italic">
        &quot;{blessing.message}&quot;
      </p>
    </div>
  );
};

export default BlessingCard;